module.exports = __webpack_public_path__ + "img/SBERBANK.d8590556.svg";